/**
 * Single source of truth for promo banner background presets.
 *
 * `backgroundColor` on a banner stores any CSS background value (a gradient from
 * the presets below, or a custom solid color picked in the admin form). Both the
 * dashboard form (swatches) and the public PromoBanner read from here.
 */
export interface PromoBannerGradientOption {
  /** Human-readable label for the dashboard selector. */
  label: string;
  /** CSS background value (a gradient). */
  value: string;
}

export const DEFAULT_PROMO_GRADIENT = 'linear-gradient(269.41deg, #FF9285 11.71%, #B57E8A 93.82%)';

export const PROMO_BANNER_GRADIENTS: PromoBannerGradientOption[] = [
  { label: 'Coral', value: DEFAULT_PROMO_GRADIENT },
  { label: 'Coral Blaze', value: 'linear-gradient(269.78deg, #FF9285 15.3%, #FF073B 98.79%)' },
  { label: 'Sage Green', value: 'linear-gradient(269deg, #8AA99B 0%, #B7C6BB 100%)' },
  { label: 'Sky Blue', value: 'linear-gradient(269deg, #6F9FBE 0%, #B8DAEE 100%)' },
  { label: 'Sunset', value: 'linear-gradient(269deg, #FF7262 0%, #FFB37B 100%)' },
  { label: 'Dusty Rose', value: 'linear-gradient(269deg, #B57E8A 0%, #D6B9AA 100%)' },
  { label: 'Plum', value: 'linear-gradient(269deg, #7C6BA8 0%, #B6A4D6 100%)' },

  { label: 'Rose Mist', value: 'linear-gradient(269deg,  #FF9285 11.71%, #B57E8A 93.82%)' },
  { label: 'Sage Bloom', value: 'linear-gradient(269deg, #9FAFA3 11.71%, #B57E8A 93.82%)' },
  { label: 'Ruby Dust', value: ' linear-gradient(269deg, #FF073B 11.71%, #B57E8A 93.82%)' },
  { label: 'Aurora Rush', value: ' linear-gradient(269deg, #A0C1D4 11.71%, #FF073B 93.82%)' },
];

/** Resolve a stored background value, falling back to the default gradient. */
export const resolvePromoBannerBackground = (backgroundColor?: string | null): string =>
  backgroundColor && backgroundColor.trim() ? backgroundColor : DEFAULT_PROMO_GRADIENT;
